import { COMPONENT_STATES, COMPONENT_TYPE } from 'common/constants';
import type { BBStates, ComponentTypes } from 'types/story';

const FIELD_TYPES = new Set<ComponentTypes>([
	COMPONENT_TYPE.TEXT_FIELD,
	COMPONENT_TYPE.TEXT_AREA_FIELD,
	COMPONENT_TYPE.CHECKBOX,
	COMPONENT_TYPE.SELECT,
	COMPONENT_TYPE.FILE_UPLOAD_FIELD,
]);

export function getStateHelp({ state, type }: { state: BBStates; type: ComponentTypes }): string {
	switch (state) {
		case COMPONENT_STATES.DEFAULT:
			return 'Controls how this element normally looks. Switch states above to style it for different interactions.';

		case COMPONENT_STATES.HOVER:
			return type === COMPONENT_TYPE.ANSWER
				? 'Controls how the answer and its content look when user points to it. Clickable content items have their own hover.'
				: 'Controls how this element looks when someone points to it. ';

		case COMPONENT_STATES.SELECTED:
			if (type === COMPONENT_TYPE.ANSWER) {
				return 'Controls how the answer and its content look after someone selects it.';
			}
			if (type === COMPONENT_TYPE.CHECKBOX) {
				return 'Controls how the checkbox looks after someone selects it.';
			}
			if (type === COMPONENT_TYPE.SWIPE) {
				return 'Controls how the swipe card looks after someone selects it.';
			}
			return 'Controls how this element looks after someone selects it.';

		case COMPONENT_STATES.CORRECT:
			return 'Controls how the answer and its content look when the answer is correct.';

		case COMPONENT_STATES.INCORRECT:
			return FIELD_TYPES.has(type)
				? 'Controls how the field looks when its value needs to be corrected.'
				: 'Controls how the answer and its content look when the answer is incorrect.';

		case COMPONENT_STATES.DISABLED:
			return 'Controls how the answer field looks when people cannot use it.';

		case COMPONENT_STATES.EMPTY:
			return 'Controls how the list looks when there is no content to show.';

		case COMPONENT_STATES.SELECTED_HOVER:
			return 'Controls how the selected element looks when someone points to it.';

		default:
			return 'Controls how this element looks in this state.';
	}
}
